import { useMutation } from '@apollo/react-hooks';
import {
  UpdateArticleBudgetCap,
  UpdateArticleBudgetCapVariables,
  UpdateArticleBudgetCap_updateArticleBudgetCap_articles
} from './__generated__/UpdateArticleBudgetCap';
import { kmsClient } from 'api';
import { UPDATE_ARTICLE_BUDGET_CAP } from './updateArticleBudgetCap.mutations';

type MutationProps = {
  onStart?: (variables: UpdateArticleBudgetCapVariables) => void;
  onCompleted?: (articles: UpdateArticleBudgetCap_updateArticleBudgetCap_articles[]) => void;
  onError?: (errors: string[]) => void;
};

export const useUpdateArticleBudgetCap = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [updateArticleBudgetCap] = useMutation<UpdateArticleBudgetCap, UpdateArticleBudgetCapVariables>(
    UPDATE_ARTICLE_BUDGET_CAP,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.updateArticleBudgetCap?.errors?.length) {
          if (onError) onError(data.updateArticleBudgetCap.errors);
        } else {
          if (onCompleted && data.updateArticleBudgetCap?.articles) onCompleted(data.updateArticleBudgetCap.articles);
        }
      },
      onError: (error) => {
        onError && onError([error.message]);
      }
    }
  );
  return (variables: UpdateArticleBudgetCapVariables) => {
    if (onStart) onStart(variables);
    updateArticleBudgetCap({ variables });
  };
};
